export default __webpack_public_path__ + "static/media/img-2.a84708d2.jpg";